import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutPreview from "./sections/AboutPreview";
import OurServices from "./sections/OurServices";
import Testimonials from "./sections/Testimonials";
import FAQ from "./sections/FAQ";
import GetStarted from "./sections/GetStarted";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutPreview />
      <OurServices />
      <Testimonials />
      <FAQ />
      <GetStarted />
      <Footer />
    </div>;
}